<template>
  <div class="card floating" id="version-history">
    <h2>{{ $t('prompts.versionHistory') }}</h2>
    <p v-html="$t('prompts.maximumLimit')"></p>
    <div class="versions">
      <item-version v-for="(version) in versions"
      :key="version.handle"
      v-bind:name="version.name"
      v-bind:size="version.size"
      v-bind:modified="version.ctime"
      v-bind:handle="version.handle"
      v-bind:index="versions.indexOf(version)"
      @remove-version="fetchData"
      ></item-version>
    </div>
    <button @click="$store.commit('closeHovers')" id="button-close" :aria-label="$t('buttons.close')" :title="$t('buttons.close')">
      <span>{{ $t('buttons.close') }}</span>
    </button>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import ItemVersion from '@/components/ItemVersion.vue';

export default {
  name: 'version-history',
  components: {
    ItemVersion
  },
  data: function () {
    return {
      versions: [],
      fileName: ''
    };
  },
  computed: {
    ...mapState([
      'req',
      'selected'
    ]),
  },
  mounted () {
    this.setIsPrompt(true);
    this.name = this.req.items[this.selected[0]].name;
    this.fetchData();
  },
  beforeDestroy () {
    this.setIsPrompt(false);
  },
  methods: {
    ...mapMutations(['closeHovers', 'setIsPrompt']),
    async fetchData() {
      this.versions = [];
      const {nodeList} = await ibb.getSortedChildren(this.req.handle, -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);

      for (let item of nodeList) {
        if (item.name === this.name) {
          this.versions.push(item);
        }
      }
    }
  }
};
</script>